// extracted by mini-css-extract-plugin
export default {"btFilter":"style_btFilter__nRFhb","filter":"style_filter__WHEoD","properties":"style_properties__rSk0d","section":"style_section__v3XQq"};